import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { PedidoBuscaSefazRequest } from '../../requests/dfe/pedido-busca-sefaz.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class PedidoBuscaSefazService extends CommonService {
  private readonly apiUrl = `${environment.urlApiDFe}pedido-busca-sefaz`;

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** A empresa vem de request.idEmpresaAlvo; a API resolve o ambiente pela configuração geral dela. */
  public criar(request: PedidoBuscaSefazRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
